<div *ngFor="let item of toastService.items$ | async">
    <app-toast-item
      [toast]="item"
    >
    </app-toast-item>
  </div>
